.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  max-inline-size: var(--content-max);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.legend {
  margin-block-end: var(--space-1);
  padding: 0;
  font-size: var(--text-xl);
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-tight);
}

.description {
  max-inline-size: var(--prose-max);
  color: var(--color-text-muted);
  font-size: var(--text-md);
}

.fields {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 14rem), var(--field-max)));
  gap: var(--space-4) var(--space-5);
  align-items: start;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: center;
}
